/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import { IAny } from '../../components/DashboardKPIWidgets/IEnergyManagementProps';
import UtilityAccountAction from './UtilityAccountActions';
import { IUtilityAccountState } from './UtilityAccountContext';

interface IAction {
  type: string;
  payload?: IAny;
  valueDetails?: IAny;
}
const utilityAccountReducer = (
  state: IUtilityAccountState,
  action: IAction
) => {
  switch (action.type) {
    case UtilityAccountAction.SHOW_MODAL:
      return {
        ...state,
        showModal: action.payload
      };
    case UtilityAccountAction.SET_SELECTED_UTILITY_INFO:
      return {
        ...state,
        selectedUtility: action.payload
      };
    case UtilityAccountAction.SHOW_DEACTIVATE_ACCOUNT_MODAL:
      return {
        ...state,
        showDeactivateAccModal: action.payload
      };
    case UtilityAccountAction.SHOW_DEACTIVATE_IDS_MODAL:
      return {
        ...state,
        showDeactivateIDSModal: action.payload
      };
    case UtilityAccountAction.SHOW_ENABLE_IDS_MODAL:
      return {
        ...state,
        showEnableIDSModal: action.payload
      };
    case UtilityAccountAction.SHOW_REACTIVATE_ACCOUNT_MODAL:
      return {
        ...state,
        showReactivateAccModal: action.payload
      };
    case UtilityAccountAction.SHOW_REACTIVATE_IDS_MODAL:
      return {
        ...state,
        showReactivateIDSModal: action.payload
      };
    case UtilityAccountAction.SHOW_REVERIFY_MODAL:
      return {
        ...state,
        showReverifyModal: action.payload
      };
    case UtilityAccountAction.SHOW_METER_NAME_CHANGE_MODAL:
      return {
        ...state,
        showMeterNameChangeModal: action.payload
      };
    case UtilityAccountAction.SHOW_CONVERSION_MODAL:
      return {
        ...state,
        showConversionModal: action.payload
      };
    case UtilityAccountAction.SHOW_CONVERSION_MODAL:
      return {
        ...state,
        showConversionModal: action.payload
      };
    case UtilityAccountAction.EDIT_DETAILS:
      return {
        ...state,
        editDetailsModal: action.payload,
        valueDetails: action.valueDetails
      };
    default:
      return state;
  }
};

export default utilityAccountReducer;
